import React, {useState, useEffect, useCallback} from 'react';
import {Link, useParams} from 'react-router-dom';
import styled from 'styled-components';

import DatabaseService from '../../services/DatabaseService';

import Layout from '../layout/Layout';

import Container from '../../common/components/Container';
import Row from '../../common/components/Row';
import Col from '../../common/components/Col';
import Card from '../../common/components/Card';
import Loading from '../../common/components/Loading';
import Button from '../../common/components/Button';
import Input from '../../common/components/Input';
import Select from '../../common/components/Select';
// import Checkbox from '../../common/components/Checkbox';
// import Textarea from '../../common/components/Textarea';
// import Datepicker from '../../common/components/Datepicker';
import Success from '../../common/components/Success';
// import Table from '../../common/components/Table';

// import {getFormattedDate} from '../../helpers';



const Header = styled.div.withConfig({displayName:'-Header'})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 40px;
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
  font-family: 'Roboto',cursive;
  font-size: 30px;
`;
const CardHeaderTitle = styled.div.withConfig({displayName:'-CardHeaderTitle'})`
  font-size: 13px;
  font-weight: 600;
  color: #303030;
  margin-bottom: 5px;
`;
const ErrorMessage = styled.div.withConfig({displayName:'-ErrorMessage'})`
  height: 30px;
  color: red;
`;

const UsersSingle = ({layout}) => {
  const {slug} = useParams();
  const [item, setItem] = useState();

  const [disabled, setDisabled] = useState(true);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    setErrorMessage(null);
    let valid = true;
    // if(!item.given_name || item.item.length === 0){
    //   valid = false;
    // }
    setDisabled(!valid);
  }, [item]);


  const getItem = useCallback(() => {
    DatabaseService.getUtente(slug).then((response) => {
      setItem(response);
    });
  }, [slug]);



  const updateItem = useCallback(() => {
    setErrorMessage("");
    DatabaseService.updateUtente(slug, item).then((response) => {
      setSuccessMessage("Dati salvati correttamente!");
      setTimeout(() => {
        setSuccessMessage(null);
      },1000)
    }).catch(error => {
      setErrorMessage(error.response.data.detail);
    });
  }, [slug, item]);

  useEffect(() => {
    getItem();
  }, [slug, getItem]);


  if(item){
    // console.log(hoovesTrims);
    return (
      <Layout layout={layout}>
        <Container>
          
          <Header>
            <Title><i className="fa-solid fa-users"></i> Utente: {item.nome}</Title>    
          </Header>

          <Row>
            <Col>
              <Card
                headerLeft={
                  <>
                    <CardHeaderTitle>Informazioni</CardHeaderTitle>
                  </>
                }
              >
                <Row>
                  <Col widthmd="6">
                    <Input
                      required
                      label="Cognome"
                      width="100%"
                      value={item.family_name}
                      onChange={(val) => {
                        let tempItem = {...item};
                        tempItem.family_name = val;
                        setItem(tempItem);
                      }}
                    />
                  </Col>
                  <Col widthmd="6">
                    <Input
                      required
                      label="Nome"
                      width="100%"
                      value={item.given_name}
                      onChange={(val) => {
                        let tempItem = {...item};
                        tempItem.given_name = val;
                        setItem(tempItem);
                      }}
                    />
                  </Col>
                  <Col widthmd="6">
                    <Select
                      required
                      label="Società"
                      maxHeight={"200px"}
                      values={[{
                        "name": "ENEL",
                        "value": "ENEL",
                      },{
                        "name": "CESI",
                        "value": "CESI",
                      },{
                        "name": "HIT MP",
                        "value": "HIT MP",
                      }]}
                      width={"100%"}
                      selected={item.address}
                      onChange={(val) => {
                        let tempItem = {...item};
                        tempItem.address = val;
                        setItem(tempItem);
                      }}
                    />
                  </Col>
                  <Col widthmd="6">
                    <Input
                      label="Email"
                      width="100%"
                      value={item.email}
                      disabled
                      onChange={(val) => {
                        let tempItem = {...item};
                        tempItem.email = val;
                        setItem(tempItem);
                      }}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
            
          </Row>
          
          <ErrorMessage>
            <br/>{errorMessage}<br/>
          </ErrorMessage>

          <div style={{"float": "right"}}><Button  onClick={disabled ? () => {} : () => updateItem(item)} variant={disabled ? "disabled" : "default"} disabled={disabled}>Salva</Button></div>
          <Link to={"/admin/users"}><Button>Indietro</Button></Link>
          

        </Container>

        {successMessage ?
          <Success fnClose={() =>setSuccessMessage(false)} message={successMessage} />
        : null}

      </Layout>
    )
  }else{
    return <Loading />;
  }
}

export default UsersSingle;
